import * as React from 'react';

const Honeypot = ({ className, ...props }) => (
  <input className="hidden" tabIndex="-1" autoComplete="false" {...props} />
);

export default Honeypot;